/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cj_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free CSV to JSON converter (and back). Paste CSV or JSON and convert instantly, with quoted-field support. Runs in your browser.`)
};

const es_cj_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertidor gratuito de CSV a JSON (y viceversa). Pega CSV o JSON y convierte al instante, con soporte para campos entre comillas. Se ejecuta en tu navegador.`)
};

const de_cj_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser CSV-zu-JSON-Konverter (und zurück). CSV oder JSON einfügen und sofort konvertieren, mit Unterstützung für in Anführungszeichen gesetzte Felder. Läuft direkt in deinem Browser.`)
};

const nl_cj_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis CSV naar JSON-converter (en omgekeerd). Plak CSV of JSON en converteer onmiddellijk, met ondersteuning voor velden tussen aanhalingstekens. Werkt in uw browser.`)
};

const fr_cj_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur CSV en JSON gratuit (et inversement). Collez CSV ou JSON et convertissez instantanément, avec support des champs entre guillemets. S'exécute dans votre navigateur.`)
};

const it_cj_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore gratuito da CSV a JSON e viceversa. Incolla CSV o JSON e converti istantaneamente, con supporto ai campi tra virgolette. Funziona nel tuo browser.`)
};

const pt_br2_cj_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor gratuito de CSV para JSON (e vice-versa). Cole CSV ou JSON e converta instantaneamente, com suporte a campos entre aspas. Funciona no seu navegador.`)
};

const pt_cj_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor gratuito de CSV para JSON (e vice-versa). Cole CSV ou JSON e converta instantaneamente, com suporte a campos entre aspas. Funciona no seu navegador.`)
};

const ja_cj_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料 CSV から JSON コンバーター（そして逆も）。CSV または JSON を貼り付けて、引用符付きフィールドのサポート付きで即座に変換します。ブラウザで実行されます。`)
};

const zh_cj_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的 CSV 转 JSON 转换器（也支持反向转换）。粘贴 CSV 或 JSON 即可即时转换，支持带引号的字段。完全在你的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cj_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cj_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cj_tool_description", locale)
	if (locale === "en") return en_cj_tool_description(inputs)
	if (locale === "es") return es_cj_tool_description(inputs)
	if (locale === "de") return de_cj_tool_description(inputs)
	if (locale === "nl") return nl_cj_tool_description(inputs)
	if (locale === "fr") return fr_cj_tool_description(inputs)
	if (locale === "it") return it_cj_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_cj_tool_description(inputs)
	if (locale === "pt") return pt_cj_tool_description(inputs)
	if (locale === "ja") return ja_cj_tool_description(inputs)
	return zh_cj_tool_description(inputs)
};